/**
 * Plantilla por defecto para el quiz del escenario 5.2 (Aurora 1 - V/F).
 * options: id, text, correct, explanation (opcional, para la afirmación falsa "infiltrada").
 */
export const DEFAULT_SCENARIO52_OPTIONS = [
	{
		id: 1,
		text: "La probabilidad de alcanzar respuesta renal completa con el tratamiento con voclosporina fue 2,05 veces mayores que con el placebo.",
		correct: false,
		explanation: "La probabilidad de alcanzar dicha RRC fueron 2,65 veces mayores con voclosporina.",
		confirmExplanation: "",
	},
	{
		id: 2,
		text: "Voclosporina reduce la proteinuria el doble de rápido que el brazo control/estándar de tratamiento actual.",
		correct: true,
		explanation: "",
		confirmExplanation: "",
	},
	{
		id: 3,
		text: "El tiempo necesario para lograr una reducción del 50 % en la UPCR con voclosporina fue de 42 días.",
		correct: false,
		explanation: "Con voclosporina se consiguió la reducción del 50 % de la UPCR en 29 días.",
		confirmExplanation: "",
	},
	{
		id: 4,
		text: "Al inicio del estudio se administró a los pacientes 0,5 g/día de metilprednisolona i. v. La dosis de glucocorticoides se fue reduciendo gradualmente de manera que, desde la semana 16 hasta el final del estudio, se administraron 2,5 mg/día de prednisona oral.",
		correct: true,
		explanation: "",
		confirmExplanation: "",
	},
];
